import PropTypes from 'prop-types';
import React from 'react';

import ReactHtmlParser from 'react-html-parser';

import Button            from '@mui/material/Button';
import Dialog            from '@mui/material/Dialog';
import DialogActions     from '@mui/material/DialogActions';
import DialogContent     from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Grid              from '@mui/material/Grid';

function PrivacyPolicyPopUp(props) {
  const { onConfirm, show, content, footer } = props;

  return (
    <Dialog
      aria-label="Privacy policy"
      open={show}
      onClose={ _ => onConfirm() }
      scroll={'paper'}
      fullWidth={true}
      maxWidth={'md'}
    >
      <DialogContent dividers>
        <DialogContentText
          tabIndex={-1}
        >
          { ReactHtmlParser(content) }
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Grid container item spacing={2}>
          <Grid item xs={12} sx={{ mx: 2, mt: 2 }}>
            { ReactHtmlParser(footer) }
          </Grid>

          <Grid item xs={12} sx={{ justifyContent: 'flex-end', alignItems: 'flex-end' }}>
            <Button sx={{ my: 2, mx: 2, float: 'right' }} variant="contained" color="primary" onClick={onConfirm} data-testid="confirm_button">
              {t('eos.landing_page.label.continue')}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}

PrivacyPolicyPopUp.defaultProps = {
  onConfirm: undefined,
  show:      undefined,
  content:   undefined,
  footer:    undefined,
};

PrivacyPolicyPopUp.propTypes = {
  onConfirm: PropTypes.func,
  show:      PropTypes.bool,
  content:   PropTypes.string,
  footer:    PropTypes.string,
};

export default PrivacyPolicyPopUp;
